import { apiClient } from "./client";

export type AnonymizationPolicy = "FULL_HIDE" | "INITIAL_ONLY" | "STATUS_ONLY" | "OPEN";

export type AnonymizedAssignment = {
  id: string;
  date: string;
  slot_template_id: string;
  exercise_mode_id: string;
  masked_label: string;
  is_mine: boolean;
  practitioner_id: string | null;
  is_cancelled: boolean;
};

export type AnonymizedPlanningView = {
  organization_id: string;
  year: number;
  month: number;
  anonymization_policy: AnonymizationPolicy;
  can_see_full_names: boolean;
  assignments: AnonymizedAssignment[];
};

export async function getAnonymizedPlanning(
  organizationId: string,
  year: number,
  month: number,
): Promise<AnonymizedPlanningView> {
  const { data } = await apiClient.get<AnonymizedPlanningView>(
    `/api/v1/views/anonymized-planning/${organizationId}/${year}/${month}`,
  );
  return data;
}
